export default __webpack_public_path__ + "static/media/logs.a7788a63.svg";